/** An older UI node must not downgrade the shared side after the server assigns its ID. */
export const getComposerAreaSideID = (nodeSideID: number | undefined, storedSideID: number | undefined, temporaryID: number) =>
    storedSideID && storedSideID > 0 ? storedSideID : nodeSideID && nodeSideID > 0 ? nodeSideID : temporaryID;
